import React from "react";
import { Link } from "react-router-dom";

export default function ErpSolutions() {
  return (
    <section
      id="caseStudies"
      className="bg-main-gray w-full py-16 md:py-[60px] bg-white"
    >
      <div className="w-full mx-auto theme-container">
        <div className="max-w-[661px] w-full flex flex-col items-center mx-auto">
              <h1 className="py-0.5 px-5 bg-buisness-red/5 border-buisness-red/10 border rounded-[30px] font-medium text-buisness-red">
            Nos Solutions ERP
          </h1>
          <h2 className="pt-5 font-semibold text-center text-black text-24 sm:text-48">
            Nos Solutions Sage 100 pour Piloter Votre Entreprise
          </h2>
        </div>
        <div className="grid grid-cols-6 lg:grid-cols-12 gap-[30px] mt-10 md:mt-[70px]">
          {/* <!-- card start  --> */}
          <div className="grid grid-cols-1 sm:grid-cols-2 bg-white p-2.5 col-span-6 rounded-3xl h3_case_card_shadow transition-all duration-300 cursor-pointer gap-4">
            <div className="flex flex-col justify-center h-full col-span-1 px-4 md:px-10">
              <p className="text-paragraph">Solution Sage 100</p>
              <h3 className="case_card_title text-black text-24 font-semibold pt-0.5">
                <Link to="/project-details"> Gestion Commerciale </Link>
              </h3>
              <p className="text-paragraph py-[30px]">
                Gérez vos ventes, achats, stocks et facturation avec une solution complète et connectée à votre comptabilité.
              </p>
              <Link to="/project-details">
                <div className="overflow-hidden flex gap-2 items-center justify-center border border-main-black/10 rounded-[41px] px-[30px] py-1.5 w-fit relative before:inline-block before:absolute before:z-0 before:w-full before:h-full before:bg-blue-seo before:scale-x-0 group hover:before:scale-x-100 before:origin-right hover:before:origin-left before:transition-transform before:ease-out before:duration-300">
                  <span className="relative z-10 font-semibold text-main-black group-hover:text-white">
                    Découvrir le module
                  </span>
                  <svg
                    className="relative z-10 transition-all duration-100"
                    width="7"
                    height="12"
                    viewBox="0 0 7 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className="transition-all duration-100 group-hover:stroke-white"
                      d="M1 10.5L4.79289 6.70711C5.12623 6.37377 5.29289 6.20711 5.29289 6C5.29289 5.79289 5.12623 5.62623 4.79289 5.29289L1 1.5"
                      stroke="#101828"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </Link>
            </div>
            <div
              data-aos="flip-right"
              data-aos-duration="1000"
              className="col-span-1 overflow-hidden rounded-2xl"
            >
              <img
                src="./assets/images/home-two/case_study/sagecommerciale.webp"
                alt=""
                className="object-cover w-full"
              />
            </div>
          </div>
          {/* <!-- card end  --> */}
          {/* <!-- card start  --> */}
          <div className="grid grid-cols-1 sm:grid-cols-2 bg-white p-2.5 col-span-6 rounded-3xl h3_case_card_shadow transition-all duration-300 cursor-pointer gap-4">
            <div className="flex flex-col justify-center h-full col-span-1 px-4 md:px-10">
              <p className="text-paragraph">Solution Sage 100</p>
              <h3 className="case_card_title text-black text-24 font-semibold pt-0.5">
                <Link to="/project-details">
                  Comptabilité
                </Link>
              </h3>
              <p className="text-paragraph py-[30px]">
                Pilotez votre gestion financière : écritures, TVA, rapprochements bancaires et états comptables en temps réel.


              </p>
              <Link to="/project-details">
                <div className="overflow-hidden flex gap-2 items-center justify-center border border-main-black/10 rounded-[41px] px-[30px] py-1.5 w-fit relative before:inline-block before:absolute before:z-0 before:w-full before:h-full before:bg-blue-seo before:scale-x-0 group hover:before:scale-x-100 before:origin-right hover:before:origin-left before:transition-transform before:ease-out before:duration-300">
                  <span className="relative z-10 font-semibold text-main-black group-hover:text-white">
                    Découvrir le module
                  </span>
                  <svg
                    className="relative z-10 transition-all duration-100"
                    width="7"
                    height="12"
                    viewBox="0 0 7 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className="transition-all duration-100 group-hover:stroke-white"
                      d="M1 10.5L4.79289 6.70711C5.12623 6.37377 5.29289 6.20711 5.29289 6C5.29289 5.79289 5.12623 5.62623 4.79289 5.29289L1 1.5"
                      stroke="#101828"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </Link>
            </div>
            <div
              data-aos="flip-right"
              data-aos-duration="1000"
              className="col-span-1 overflow-hidden rounded-2xl"
            >
              <img
                src="/assets/images/home-three/case/compta.png"
                alt=""
                className="object-cover w-full"
              />
            </div>
          </div>
          {/* <!-- card end  --> */}
          {/* <!-- card start  --> */}
          <div className="grid grid-cols-1 sm:grid-cols-2 bg-white p-2.5 col-span-6 rounded-3xl h3_case_card_shadow transition-all duration-300 cursor-pointer gap-4">
            <div className="flex flex-col justify-center h-full col-span-1 px-4 md:px-10">
              <p className="text-paragraph">Solution Sage 100</p>
              <h3 className="case_card_title text-black text-24 font-semibold pt-0.5">
                <Link to="/project-details">Gestion des Immobilisations</Link>
              </h3>
              <p className="text-paragraph py-[30px]">
                Suivez le cycle de vie de vos actifs, calculez automatiquement les amortissements et sécurisez vos obligations comptables.
              </p>
              <Link to="/project-details">
                <div className="overflow-hidden flex gap-2 items-center justify-center border border-main-black/10 rounded-[41px] px-[30px] py-1.5 w-fit relative before:inline-block before:absolute before:z-0 before:w-full before:h-full before:bg-blue-seo before:scale-x-0 group hover:before:scale-x-100 before:origin-right hover:before:origin-left before:transition-transform before:ease-out before:duration-300">
                  <span className="relative z-10 font-semibold text-main-black group-hover:text-white">
                    Découvrir le module
                  </span>
                  <svg
                    className="relative z-10 transition-all duration-100"
                    width="7"
                    height="12"
                    viewBox="0 0 7 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className="transition-all duration-100 group-hover:stroke-white"
                      d="M1 10.5L4.79289 6.70711C5.12623 6.37377 5.29289 6.20711 5.29289 6C5.29289 5.79289 5.12623 5.62623 4.79289 5.29289L1 1.5"
                      stroke="#101828"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </Link>
            </div>
            <div
              data-aos="flip-right"
              data-aos-duration="1000"
              className="col-span-1 overflow-hidden rounded-2xl"
            >
              <img
                src="/assets/images/home-three/case/sage_100c_immobilisations-functions_de_base.jpg"
                alt=""
                className="object-cover w-full"
              />
            </div>
          </div>
          {/* <!-- card end  --> */}
          {/* <!-- card start  --> */}
          <div className="grid grid-cols-1 sm:grid-cols-2 bg-white p-2.5 col-span-6 rounded-3xl h3_case_card_shadow transition-all duration-300 cursor-pointer gap-4">
            <div className="flex flex-col justify-center h-full col-span-1 px-4 md:px-10">
              <p className="text-paragraph">Solution Sage 100</p>
              <h3 className="case_card_title text-black text-24 font-semibold pt-0.5">
                <Link to="/project-details">
                  Paie & RH
                </Link>
              </h3>
              <p className="text-paragraph py-[30px]">
                Automatisez la paie, gérez les déclarations sociales et pilotez vos ressources humaines en toute conformité.
              </p>
              <Link to="/project-details">
                <div className="overflow-hidden flex gap-2 items-center justify-center border border-main-black/10 rounded-[41px] px-[30px] py-1.5 w-fit relative before:inline-block before:absolute before:z-0 before:w-full before:h-full before:bg-blue-seo before:scale-x-0 group hover:before:scale-x-100 before:origin-right hover:before:origin-left before:transition-transform before:ease-out before:duration-300">
                  <span className="relative z-10 font-semibold text-main-black group-hover:text-white">
                    Découvrir le module
                  </span>
                  <svg
                    className="relative z-10 transition-all duration-100"
                    width="7"
                    height="12"
                    viewBox="0 0 7 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className="transition-all duration-100 group-hover:stroke-white"
                      d="M1 10.5L4.79289 6.70711C5.12623 6.37377 5.29289 6.20711 5.29289 6C5.29289 5.79289 5.12623 5.62623 4.79289 5.29289L1 1.5"
                      stroke="#101828"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </Link>
            </div>
            
            <div
              data-aos="flip-right"
              data-aos-duration="1000"
              className="col-span-1 overflow-hidden rounded-2xl"
            >
              <img
                src="/assets/images/home-three/case/Mdp_Gestion des mandats.jpg"
                alt=""
                className="object-cover w-full"
              />
            </div>
          </div>
          {/* <!-- card end  --> */}
        </div>
      </div>
    </section>
  );
}
